import type { Table } from "dexie";
import { BaseDexieRepository } from "./base-repository";
import type { AudioRecordingTranscriptSnapshotRecord } from "@/domains/dexie-db/models/audio-recording";

export class AudioRecordingTranscriptSnapshotsRepository extends BaseDexieRepository<AudioRecordingTranscriptSnapshotRecord> {
  constructor(table: Table<AudioRecordingTranscriptSnapshotRecord, number>) {
    super(table);
  }

  async insert({
    recordingId,
    noteId,
    channel,
    snapshotTime,
    transcripts,
    createdAt = Date.now(),
  }: {
    recordingId: string;
    noteId?: string;
    channel: number;
    snapshotTime: number;
    transcripts: AudioRecordingTranscriptSnapshotRecord["transcripts"];
    createdAt?: number;
  }): Promise<void> {
    await this.table.add({ recordingId, noteId, channel, snapshotTime, transcripts, createdAt });
  }

  async listByRecordingId(recordingId: string): Promise<AudioRecordingTranscriptSnapshotRecord[]> {
    return this.table.where({ recordingId }).toArray();
  }

  async deleteByRecordingId(recordingId: string): Promise<void> {
    await this.table.where({ recordingId }).delete();
  }

  async deleteByRecordingIdAndChannel(recordingId: string, channel: number): Promise<void> {
    await this.table.where({ recordingId, channel }).delete();
  }

  async clearByNoteId(noteId: string): Promise<void> {
    await this.table.where({ noteId }).delete();
  }
}
